<template>
  <div class="field-wrapper">
    <PeriodSelector
      v-model="period"
      :units="units"
      title="automatedScenarios.fields.delay"
    />
    <FieldErrors
      :key="componentFieldErrorsKey"
      :errors="formValidationErrors"
      field="time_unit_select"
    />
  </div>
</template>

<script lang="ts">
import { useI18n } from 'vue-i18n';
import PeriodSelector from '@/components/automated-scenarios/fields/PeriodSelector.vue';

import {
  defineComponent,
  PropType, ref, SetupContext, watch,
} from 'vue';
import { asInt } from '@/helpers';
import ActionDelaisMaxMetadata, {
  ActionDelaisMaxData,
} from '@/components/automated-scenarios/metadata/actions/ActionDelaisMaxMetadata';
import { Period } from '@/types/automated-scenarios';
import FieldErrors from '@/components/fields/partials/FieldErrors.vue';

export default defineComponent({
  name: 'ActionDelaisMax',
  components: {
    FieldErrors,
    PeriodSelector,
  },

  props: {
    modelValue: {
      type: Object as PropType<ActionDelaisMaxData>,
      required: true,
      default() {
        return ActionDelaisMaxMetadata.Create();
      },
    },

    formValidation: {
      type: Object,
      required: false,
      default() {
        return {};
      },
    },
  },

  emits: ['update:modelValue'],

  setup(props: { modelValue: ActionDelaisMaxData; formValidation: any }, context: SetupContext) {
    const { t } = useI18n();
    const formValidationErrors = ref(props.formValidation);
    const componentFieldErrorsKey = ref(0);
    watch(() => props.formValidation, () => {
      formValidationErrors.value = props.formValidation;
      componentFieldErrorsKey.value += 1;
    });

    const units = [
      { value: 'SECOND', label: t('automatedScenarios.fields.durations.second(s)') },
      { value: 'MINUTE', label: t('automatedScenarios.fields.durations.minute(s)') },
      { value: 'HOUR', label: t('automatedScenarios.fields.durations.hour(s)') },
      { value: 'DAY', label: t('automatedScenarios.fields.durations.day(s)') },
    ];

    const period = ref<Period>({
      unit: props.modelValue.time_unit_select.unit,
      value: asInt(props.modelValue.time_unit_select.value),
    });

    const update = () => context.emit('update:modelValue', ActionDelaisMaxMetadata.Create({
      time_unit_select: {
        value: period.value.value,
        unit: period.value.unit,
      },
    }));

    watch([period], update);

    return {
      formValidationErrors,
      componentFieldErrorsKey,
      units,
      period,
    };
  },
});
</script>
